import {gql} from '@apollo/client'

export const CREATE_UPDATE_PRODUCT = gql`
  mutation productCreateUpdate($input: ProductCreateUpdateMutationInput!) {
    productCreateUpdate(input: $input) {
      clientMutationId
      errors {
        field
        messages
      }
      product {
        id
      }
    }
  }
`
